export const StringTemplateStartRule = 'StringTemplate';